import { Component, Input } from "@angular/core";

import { Config } from "src/app/config";
import { StyleColors } from "src/app/models/style-colors";
import { ExamService } from "src/app/services/exam.service";
import { Menu } from "src/app/models/menu";
import { Exam } from "src/app/models/exam";
import { EventsHubService } from "src/app/services/eventshub.service";

@Component({
  selector: "hkt-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SideBarComponent {
  @Input("mode") mode: string;

  menu: Menu[];
  pages: string[];
  styleColors: StyleColors;
  sideBarOpen: boolean;
  currentPage: string;

  constructor(private examService: ExamService, private eventsHubService: EventsHubService) {
    this.styleColors = {
      title: { bg: "#FF0", color: "#000" },
      technique: { bg: "#F0F", color: "#000" },
      variation: { bg: "#0FF", color: "#000" },
      pac: { bg: "#F00", color: "#000" },
      exam: { bg: "#00F", color: "#000" },
      default: { bg: "transparent", color: "#000" },
    };

    this.sideBarOpen = false;

    this.menu = null;
    this.pages = [];

    this.examService.onCurrentExamChange.subscribe(exam => {
      this.loadStyleColors(exam);
      if (exam.menu.length > 0) {
        this.menu = exam.menu;
        if (this.mode == "exam") {
          this.collapseMenu(this.menu);
        }
      }
      this.pages = exam.pages.map(item => item.name);
    });

    this.examService.onCurrentPageChange.subscribe(pageIndex => {
      this.currentPage = this.pages[pageIndex];
    });
  }

  private loadStyleColors(exam: Exam) {
    let style = Config.STYLE[exam.style];
    if (style) {
      this.styleColors = {
        title: style["color-title"],
        technique: style["color-technique"],
        variation: style["color-variation"],
        pac: style["color-pac"],
        exam: style["color-exam"],
        default: style["color-default"],
      };
    }
  }

  private collapseMenu(menu: Menu[]) {
    for (let m of menu) {
      m.showSubMenu = false;
      if (m.subMenu) {
        this.collapseMenu(m.subMenu);
      }
    }
  }

  private collapseSiblingMenu(menu: Menu[], m: Menu) {
    let findParentMenu = (list: Menu[], parent: Menu) => {
      for (let i of list) {
        if (i == m) {
          return parent;
        }
        if (i.subMenu) {
          let ret = findParentMenu(i.subMenu, i);
          if (ret != null) {
            return ret;
          }
        }
      }
      return null;
    };
    let parent = findParentMenu(menu, null);
    if (parent != null) {
      menu = parent.subMenu;
    }

    for (let mm of menu) {
      if (mm != m) {
        mm.showSubMenu = false;
        if (mm.subMenu) {
          this.collapseMenu(mm.subMenu);
        }
      } else {
        m.showSubMenu = true;
      }
    }
  }

  onClickMenu(menu: Menu): void {
    let pageIndex = this.pages.indexOf(menu.pageName);
    if (pageIndex >= 0) {
      this.eventsHubService.changePage(pageIndex);
    }
  }

  onClickToggleMenu(menu: Menu): void {
    menu.showSubMenu = !menu.showSubMenu;
    if (menu.showSubMenu) {
      this.collapseSiblingMenu(this.menu, menu);
    }
  }

  onClickToggle(): void {
    this.sideBarOpen = !this.sideBarOpen;
  }

  getStyleColor(style: string): string {
    if (style) {
      let color = this.styleColors[style];
      if (color) {
        return color.color;
      }
    }
    return this.styleColors.default.color;
  }

  getStyleBgColor(style: string): string {
    if (style) {
      let color = this.styleColors[style];
      if (color) {
        return color.bg;
      }
    }
    return this.styleColors.default.bg;
  }
}
